import type { ComponentType } from "react";
import {
  Button,
  Flex,
  Heading,
  Image,
  Text,
  View,
} from "@aws-amplify/ui-react";

import evidoLogoUrl from "@assets/logos/main_logo_green.png";
import type { AppRole } from "@/auth/roles";

type AppProperties = {
  userName: string;
  role: AppRole;
  onSignOut?: () => void;
  StorageBrowser: ComponentType;
};

const CONTENT_MAX_WIDTH = "80rem";

const ROLE_LABELS: Record<AppRole, string | undefined> = {
  customer: undefined,
  analyst: "Analyst",
  qualityControl: "Quality Control",
};

export function App({
  userName,
  role,
  onSignOut,
  StorageBrowser,
}: AppProperties) {
  const roleLabel = ROLE_LABELS[role];
  return (
    <Flex
      backgroundColor="background.secondary"
      direction="column"
      gap="0"
      minHeight="100vh"
    >
      <Flex
        alignItems="center"
        as="header"
        backgroundColor="primary.80"
        justifyContent="space-between"
        padding="1.25rem 2rem"
      >
        <View>
          <Heading color="white" level={1}>
            LiverPRO Cloud
          </Heading>
          <Text color="white" fontSize="13px">
            Signed in as {userName}
            {roleLabel ? ` · ${roleLabel}` : null}
          </Text>
        </View>

        <Button
          className="evido-button--secondary"
          onClick={onSignOut}
          size="small"
        >
          Sign out
        </Button>
      </Flex>

      <Flex
        as="main"
        flex="1"
        justifyContent="center"
        minHeight="0"
        padding="1.5rem"
      >
        <View
          backgroundColor="background.primary"
          borderRadius="large"
          flex="1"
          maxWidth={CONTENT_MAX_WIDTH}
          overflow="hidden"
        >
          <StorageBrowser />
        </View>
      </Flex>

      <View as="footer" padding="1.5rem" textAlign="center">
        <Image alt="evido.health" src={evidoLogoUrl} width="150px" />
      </View>
    </Flex>
  );
}
